import { AboutMixProofValves } from './about-mix-proof-valves';

export const InfoMixProof: React.FC = () => {
  return <AboutMixProofValves maxWidth={540} />;
};
